import { Link } from 'react-router-dom';
import { articles } from '../../data/content';
import './BlogPreview.css';

function BlogPreview() {
  return (
    <section id="artigos" className="section blog-preview">
      <div className="container">
        <div className="section-header">
          <h2>Artigos</h2>
          <p>Conteúdo sobre automação, integração e transformação digital.</p>
        </div>

        <div className="articles-grid">
          {articles.slice(0, 6).map((article) => (
            <Link key={article.slug} to={`/blog/${article.slug}`} className="article-card">
              <h3>{article.title}</h3>
              <p>{article.excerpt}</p>
              <span className="article-link">Ler artigo →</span>
            </Link>
          ))}
        </div>

        <div className="blog-cta">
          <Link to="/blog" className="btn btn-outline">Ver todos os artigos</Link>
        </div>
      </div>
    </section>
  );
}

export default BlogPreview;
